import { ReactNode, createContext, useContext, useRef } from "react";
import { LoadingManager } from "./loadingManager";
import { useBehaviorSubject, useObservable } from "react-rxjs-toolkit";
import { LoadingScreen } from "./LoadingScreen";

const TRANSITION_TIME_MS = 1000;
const PROGRESS_BAR_TRANSITION_MS = 300;
const LoadingContext = createContext(
  new LoadingManager({ transitionTimeMs: TRANSITION_TIME_MS })
);

export const useLoading = () => {
  return useContext(LoadingContext);
};

export const LoadingProvider = ({ children }: { children: ReactNode }) => {
  const loadingManagerRef = useRef(
    new LoadingManager({ transitionTimeMs: TRANSITION_TIME_MS })
  );
  const [showLoading] = useObservable(
    loadingManagerRef.current.showLoadingScreen$,
    true
  );
  const [shouldRenderLoadingScreen] = useBehaviorSubject(
    loadingManagerRef.current.shouldRenderLoadingScreen$
  );
  const [task] = useObservable(loadingManagerRef.current.currentTask$);

  return (
    <LoadingContext.Provider value={loadingManagerRef.current}>
      {shouldRenderLoadingScreen ? (
        <LoadingScreen
          task={task ?? undefined}
          progressBarTransitionMs={PROGRESS_BAR_TRANSITION_MS}
          opacity={showLoading ? "1" : "0"}
          transition={`opacity ${TRANSITION_TIME_MS / 1000}s`}
        />
      ) : null}
      {children}
    </LoadingContext.Provider>
  );
};
